import { whenAny, whenPathEquals } from './conditions';
import { locationFootprintFieldRule } from './location-footprint';
import { sharedFieldOrder } from './shared-field-order';
import type { IncidentFieldRule } from './types';

const projectScopeSelected = whenPathEquals('location.scope', 'Project');
const affectedFunctionIsDevelopment = whenPathEquals('reportedByFunction', 'Development');

export const generalObservationFieldRules: IncidentFieldRule[] = [
    {
        key: 'summary',
        label: 'Summary',
        order: sharedFieldOrder.summary,
    },
    {
        key: 'occurredAt',
        label: 'When did this happen?',
        description: 'Enter the date and time the incident occurred.',
        order: sharedFieldOrder.occurredAt,
    },
    {
        key: 'description',
        label: 'Describe what happened',
        description: 'Provide a clear summary including key facts and sequence of events.',
        order: sharedFieldOrder.description,
    },
    {
        key: 'location.scope',
        label: 'Where did this happen?',
        description:
            'Select where the incident occurred. Use Project for construction projects or non-operational sites.',
        order: sharedFieldOrder.locationScope,
    },
    {
        // Hidden (derived from the footprint picker); the rule stays because it also supplies the
        // field's catalog options. location.locationIds is hidden centrally in shared-overrides.ts.
        key: 'location.sites',
        hidden: true,
    },
    {
        // Driven by the cascading locationFootprint picker, never shown raw (mirrors
        // general-incident). Without this, observation forms leak a plain "Location Ids"
        // multiselect alongside the picker.
        key: 'location.locationIds',
        hidden: true,
    },
    locationFootprintFieldRule,
    {
        key: 'reportedByFunction',
        label: 'Which function is affected?',
        description: 'Choose the business function impacted by this incident.',
        order: sharedFieldOrder.reportedByFunction,
    },
    {
        key: 'location.projectName',
        label: 'Project name',
        order: sharedFieldOrder.locationProjectName,
        visibleWhen: whenAny(projectScopeSelected, affectedFunctionIsDevelopment),
        requiredWhen: projectScopeSelected,
    },
    {
        key: 'thirdPartyInvolved',
        label: 'Was a third party involved?',
        description: 'Select Yes if any external party (contractor, vendor, visitor) was involved.',
        order: sharedFieldOrder.thirdPartyInvolved,
    },
    {
        key: 'attachments',
        label: 'Attach related files',
        description: 'Attach relevant files such as photos, documents, or screenshots.',
        order: sharedFieldOrder.attachments,
    },
];
